import {
  setMapLoaded,
  setMapOpen,
  showJourneyMap,
} from '@/features/map-component/mapComponentActions';
import type { SearchJourneyOffersDTO } from '@/types/dto/agent';
import { createReducer } from '@reduxjs/toolkit';

export interface MapComponentState {
  isMapLoaded: boolean;
  isMapOpen: boolean;
  journey: SearchJourneyOffersDTO | null;
}

const initialState: MapComponentState = {
  isMapLoaded: false,
  isMapOpen: false,
  journey: null,
};

export const mapComponentReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setMapLoaded, (state, action) => {
      state.isMapLoaded = action.payload;
    })
    .addCase(setMapOpen, (state, action) => {
      state.isMapOpen = action.payload;
    })
    .addCase(showJourneyMap, (state, action) => {
      state.journey = action.payload;
      state.isMapOpen = true;
    });
});
